import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getTermDeposits = (state: AppState) => state.termDepositOpen;
const getInfo = (state: AppState) => state.termDepositOpen.responseInfo;
const getTerm = (state: AppState) => state.termDepositOpen.responseTerm;
const getMaturity = (state: AppState) => state.termDepositOpen.responseMaturity;
const getDataCreate = (state: AppState) => state.termDepositOpen.dataCreate;
const getResponseCreated = (state: AppState) => state.termDepositOpen.responseCreate;
const getResponseConfirm = (state: AppState) => state.termDepositOpen.responseConfirm;
const getResponseAuth = (state: AppState) => state.termDepositOpen.responseAuth;
const getResponsePromotions = (state: AppState) => state.termDepositOpen.resPromotions;

const getPending = (state: AppState) => state.termDepositOpen.pending;

export const getTermDepositOpenSelector = createSelector(getTermDeposits, (data) => data);
export const getTermDepositInfoSelector = createSelector(getInfo, (info) => info);
export const getTermDepositTermSelector = createSelector(getTerm, (term) => term);
export const getTermDepositMaturitySelector = createSelector(getMaturity, (mat) => mat);

export const getTermDepositDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getTermDepositResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTermDepositResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getTermDepositResponseAuthSelector = createSelector(getResponseAuth, (res) => res);
export const getTermDepositResponsePromotionsSelector = createSelector(getResponsePromotions, (res) => res);

export const getTermDepositOpenPendingSelector = createSelector(getPending, (status) => status);
